import { useMutation } from "@tanstack/react-query";
import { Spin, Switch, message } from "antd";
import { AiOutlineEdit } from "react-icons/ai";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FormattedMessage, useIntl } from "react-intl";
import { updateLoyaltyProgram } from "../../network/settings";
import queryClient from "../../services/react-query/queryClient";

type Props = {
  data: any;
  isModalOpen: any;
  showDeleteModal: any;
};

const CardProgramLoyalty = ({ data, isModalOpen, showDeleteModal }: Props) => {
  const { mutate: updatePayment, isLoading: isUpdateing } = useMutation(
    updateLoyaltyProgram,
    {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST") {
          message.error(res?.response?.data?.message);
        } else {
          console.log(res, "res");
          message.success("loyalty updated successfully");
          queryClient.invalidateQueries(["loyalty"]);
        }
      },
    }
  );
  const intl = useIntl();
  return isUpdateing ? (
    <Spin size="large" className="flex items-center justify-center" />
  ) : (
    <div
      style={{
        border: "solid 1px #00086D",
        background: data?.is_active ? "#EEF0FF" : "#FBFBFF",
      }}
      className={"flex flex-col gap-5 p-4 pt-3 h-full rounded-lg"}
    >
      <div className="flex items-center justify-between">
        <span>{data?.name}</span>
        <div className="flex items-center gap-2">
          <AiOutlineEdit
            onClick={() => isModalOpen(data)}
            className="cursor-pointer text-color-primary"
          />
          <MdOutlineDeleteForever
            onClick={() => showDeleteModal(data?.id)}
            className="text-[#C43535] cursor-pointer"
          />
        </div>
      </div>

      {data?.ranges?.map((e: any) => {
        return (
          <div className="grid gap-2">
            <div className="flex items-center gap-3">
              <div
                style={{
                  background: data?.is_active
                    ? "white"
                    : "rgba(176, 176, 192, 0.20)",
                }}
                className="flex items-center justify-center w-full h-full px-2 py-1 rounded-lg"
              >
                <span className="text-sm font-semibold text-color-primary whitespace-nowrap">
                  {e?.from_amount} - {e?.to_amount}
                </span>
                <span className="text-[8px] text-[#9999A7] mt-1 mx-1 whitespace-nowrap">
                  {intl.formatMessage({
                    id: "SAR",
                  })}
                </span>
              </div>
              <div
                style={{
                  background: data?.is_active
                    ? "white"
                    : "rgba(176, 176, 192, 0.20)",
                }}
                className="flex items-center justify-center w-1/2 h-full gap-1 px-2 py-1 text-xs rounded-lg whitespace-nowrap"
              >
                <span className="text-[#9999A7]">
                  {intl.formatMessage({
                    id: "discount",
                  })}
                </span>
                <span className="text-sm font-semibold text-color-primary whitespace-nowrap">
                  - {e?.discount_percentage}%
                </span>
              </div>
            </div>
          </div>
        );
      })}
      <div className="flex items-center justify-between mt-auto text-sm">
        <FormattedMessage id="setAsCurrentProgram" />
        <Switch
          value={data?.is_active}
          onChange={(e) => updatePayment({ id: data?.id, is_active: e })}
          className="flex items-center"
        />
      </div>
    </div>
  );
};

export default CardProgramLoyalty;
